import s from "./UserInfo.module.scss"

export const UserInfoMobileSkeleton = () => {
  return (
    <div className={s.skeleton}>
      <div className={s.skeleton__completed} />
      <div className={s.skeleton__stars} />
    </div>
  )
}
